import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
export const SidebarContext = createContext(undefined);
export const SidebarProvider = ({ children }) => {
    const [sidebarState, setSidebarState] = useState();
    const updateSidebarState = useCallback((values) => {
        setSidebarState((prevState) => ({ ...prevState, ...values }));
    }, []);
    const updateToggleState = useCallback(() => {
        setSidebarState((prevState) => ({ ...prevState, toggled: !prevState?.toggled }));
    }, []);
    const providerValue = useMemo(() => ({ ...sidebarState, updateSidebarState, updateToggleState }), [sidebarState, updateSidebarState, updateToggleState]);
    return _jsx(SidebarContext.Provider, { value: providerValue, children: children });
};
export const useSidebarContext = () => {
    const context = useContext(SidebarContext);
    if (context === undefined) {
        throw new Error('Sidebar components must be wrapped in <SidebarProvider />');
    }
    return context;
};
export const useSidebar = () => {
    const { updateSidebarState, updateToggleState, toggled, broken } = useSidebarContext();
    const toggleSidebar = useCallback((value) => {
        if (value === undefined)
            updateToggleState();
        else
            updateSidebarState({ toggled: value });
    }, [updateToggleState, updateSidebarState]);
    return {
        toggleSidebar,
        broken: !!broken,
        toggled: !!toggled,
    };
};
export const LevelContext = createContext(0);
export const useLevelContext = () => {
    const context = useContext(LevelContext);
    return context;
};
